import * as React from 'react';

import {Card} from '../../card/card';
import {colors} from '../../colors/colors';
import {File} from '../../files/file';

import type {File as FileType} from '../types';

type Props = {
    files: FileType[];
};

export function TimelineBannerFilesCard(props: Props) {
    const files = props.files.map((file) => (
        <File
            key={file.fileId}
            id={file.fileId}
            filename={file.name}
            filetype={file.fileType}
            href={file.href}
            withNoBorder={true}
        />
    ));

    return (
        <Card hasBorder={true} hasShadow={true} fitHeight={true} leftLineColor={colors.grey}>
            <div className='pad-8'>{files}</div>
        </Card>
    );
}
